



















import { Vue, Prop, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CartModule from '@/store/modules/cart-module';
import WishlistModule from '@/store/modules/wishlist-module';
import ProductItem from '@/models/product-item';
import store from '@/store';
const cartModule = getModule(CartModule, store);
const wishlistModule = getModule(WishlistModule, store);

@Component
export default class DmqProductActions extends Vue {

  @Prop({
    required: true,
    type: Object,
  })
  private readonly pageProduct!: ProductItem;

  @Prop({
    required: true,
    type: String,
  })
  private readonly addToCartLabel!: string;

  @Prop({
    required: true,
    type: String,
  })
  private readonly maxOrderedLabel!: string;

  @Prop({
    required: true,
    type: String,
  })
  private readonly notAvailableLabel!: string;

  private qty: number = 0;

  protected mounted() {
    if (this.product.availableQty < 0 || this.product.availableQty > 0) {
      this.qty = 1;
    }
  }

  private get cartLine() {
    for (const rs of cartModule.cart.retailerSections) {
      for (const line of rs.lines) {
        if (line.product.id === this.pageProduct.id) {
          return line;
        }
      }
    }
    return null;
  }

  private get cartProduct() {
    const line = this.cartLine;
    if (line) {
      return line.product;
    }
    return null;
  }

  private get product() {
    const cp = this.cartProduct;
    if (cp !== null) {
      return cp;
    }
    return this.pageProduct;
  }

  private get notAvailable() {
    return this.product.availableQty === 0;
  }

  private get orderedQty() {
    console.log('CART QTY', this.product.userCartQty);
    return this.product.userCartQty;
  }

  private get maxOrdered() {
    if (this.product.availableQty >= 0) {
      return this.orderedQty >= this.product.availableQty;
    }
    return false;
  }

  private get availableQty() {
    if (this.product.availableQty >= 0) {
      return this.product.availableQty - this.orderedQty;
    }
    return -1;
  }

  private get addToCartButtonDisabled() {
    return this.qty < 1 || (this.qty > this.availableQty && this.product.availableQty >= 0);
  }

  private increment() {
    if (this.product.availableQty < 0 || this.qty + 1 <= this.availableQty) {
      this.qty += 1;
    }
  }

  private decrement() {
    if (this.qty - 1 > 0) {
      this.qty -= 1;
    }
  }

  private addToCart() {
    cartModule.add({
      code:'',
      retCode: -1,
      message: '',
      reduction: 0,
      typeReduction: '',
      productId: this.pageProduct.id,
      quantity: this.qty,
    });
  }

}

